module.exports = __webpack_public_path__ + "static/media/nevada_sunset.e3146c7c.jpeg";